<template>
  <div>
    <h1>001</h1>
    <h1>VIP {{ $route.params.id }} 活动页面</h1>
  </div>
</template>

<script>
export default {
 
}
</script>